import { Typography } from '@mui/material'
import * as S from './Header.styles'

interface HeaderProps {
  title: string
}

const Header: React.FC<HeaderProps> = ({
  title,
}): JSX.Element => (
  <S.Container>
    <Typography>{title}</Typography>
  </S.Container>
)

export default Header
